import { useMemo } from 'react';

const useSessionInvitation = () => {
  return useMemo(() => {
    // Will Always get Session Storage
    try {
      const stringifyInvitation = localStorage.getItem('invitation');
      return JSON.parse(stringifyInvitation) || {};
    } catch (error) {
      return {};
    }
  });
};

export default useSessionInvitation;
